import React ,{ useEffect,useRef  } from 'react';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import LandingPage from './pages/LandingPage';
import WhatisPreIpo from './pages/WhatisPreIpo';
import Careers from './pages/Careers';
import {BrowserRouter, Routes, Route,useLocation} from 'react-router-dom';
import FooterComponent from './components/footer';
import HeaderComponent from './components/header';
import AOS from "aos";
import "aos/dist/aos.css";
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";

function App() {
  useEffect(() => {
    // ✅ Initialize AOS animations
    AOS.init({
      duration: 600,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });

    
    // ✅ Apply .scrolled class on scroll
    const toggleScrolled = () => {
      const selectBody = document.body;
      const selectHeader = document.querySelector("#header");
      if (
        !selectHeader?.classList.contains("scroll-up-sticky") &&
        !selectHeader?.classList.contains("sticky-top") &&
        !selectHeader?.classList.contains("fixed-top")
      )
        return;
      window.scrollY > 100
        ? selectBody.classList.add("scrolled")
        : selectBody.classList.remove("scrolled");
    };
    window.addEventListener("scroll", toggleScrolled);
    toggleScrolled();

    // ✅ Scroll-to-Top Button
    const scrollTopBtn = document.querySelector(".scroll-top");
    const toggleScrollTop = () => {
      if (scrollTopBtn) {
        window.scrollY > 100
          ? scrollTopBtn.classList.add("active")
          : scrollTopBtn.classList.remove("active");
      }
    };
    if (scrollTopBtn) {
      scrollTopBtn.addEventListener("click", (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
    window.addEventListener("scroll", toggleScrollTop);
    toggleScrollTop();

    // ✅ Lightbox Initialization
    const lightbox = GLightbox({ selector: ".glightbox" });

    // ✅ Initialize Swiper Sliders
    const initSwiper = () => {
      document.querySelectorAll(".init-swiper").forEach((swiperElement) => {
        let config = JSON.parse(
          swiperElement.querySelector(".swiper-config").innerHTML.trim()
        );
        new Swiper(swiperElement, config);
      });
    };
    initSwiper();

    // ✅ Clean up event listeners on unmount
    return () => {
      window.removeEventListener("scroll", toggleScrolled);
      window.removeEventListener("scroll", toggleScrollTop);
    };
  }, []);
  return (
    <BrowserRouter>
    <HeaderComponent/>
    <main className="main">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<Careers/>}/>
        <Route path="/whatispreipo" element={<WhatisPreIpo/>}/>
      </Routes>
      <FooterComponent/>
      <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center">
        <i className="bi bi-arrow-up-short"></i>
      </a>

      {/* Preloader */}
      {/* <div id="preloader"></div> */}
      </main>
    </BrowserRouter>
   
  )
}

export default App